import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["rename", "keyname", "visible", "children"];
import React, { useEffect, memo } from 'react';
import { useStore } from './store';
import { jsx as _jsx } from "react/jsx-runtime";
export var Input = /*#__PURE__*/memo(props => {
  var {
    fields = {},
    extra = {},
    $$index = {},
    dispatch
  } = useStore();
  var {
      rename,
      keyname,
      visible = true,
      children
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(() => {
    if (keyname || elmProps.name) {
      var key = keyname || elmProps.name;
      delete $$index[key];
      delete fields[key];
      delete extra[key];
      dispatch({
        $$index: _extends({}, $$index, {
          [key]: elmProps.index || 0
        }),
        extra: _extends({}, extra, {
          [key]: children || null
        }),
        fields: _extends({}, fields, {
          [key]: visible ? /*#__PURE__*/_jsx("input", _extends({}, elmProps, {
            name: rename || elmProps.name
          })) : null
        })
      });
    }
  }, [props]);
  return null;
});
Input.displayName = 'Login.Input';